import { FC } from "react";

import { UiColors } from "../../../../config/ui/colors";

import { CustomizedYAxisTickBarsProps } from "./CustomizedYAxisTickBars.type";

const CustomizedYAxisTickBars: FC<CustomizedYAxisTickBarsProps> = ({ x, y, fontSize, payload }) => (
	<g transform={`translate(${x},${y})`}>
		<text fontSize={`${fontSize || 14}px`} x={0} y={0} dy={0} textAnchor="end" alignmentBaseline="middle" fill={UiColors.black}>
			{payload.value}
		</text>
	</g>
);

export { CustomizedYAxisTickBars };
